<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom pb-5">
        <div class="row">
            <div class="col-10">
                <h4 class="fs-title">User Rights</h4>
            </div>
        </div>
        <div class="row card">
            <div class="col-lg-12">
                <div class="row justify-content-center">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <form #userForm="ngForm" (ngSubmit)="getUserRightsList()" class="pb-3">
                            <div class="row ">
                                <div class="col-lg-4 col-md-4 col-12">
                                    <label>User
                                        <span class="text-danger">*</span>
                                    </label>
                                    <select class="form-control" #UserID name="UserID" id="UserID" required>
                                        <option *ngFor="let u of users" [value]="u.value">
                                            {{ u.text }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-3 pt-2" style="margin-left: -5px;">
                                <button class="btn btn-success" type="submit"
                                    style="margin: 5px;">{{btnsubmittext}}</button>
                                <button class="btn btn-primary" type="button" (click)="resetAll()"
                                    style="margin: 5px;">Cancel</button>
                            </div>
                        </form>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-12">
                                <div class="table-responsive subject">
                                    <div *ngIf="UserRightsList != undefined && UserRightsList.length != 0">
                                        <table id="example" class="table table-striped table-bordered"
                                            style="width:100%">
                                            <thead>
                                                <tr>
                                                    <th>Allow <input type="checkbox" id="isAllowAll"
                                                            (change)="checkall('isAllowAll','allow')"> </th>
                                                    <th>Form Title</th>
                                                    <th>ADD <input type="checkbox" id="isAddAll"
                                                            (change)="checkall('isAddAll','isAdd')"></th>
                                                    <th>EDIT <input type="checkbox" id="isEditAll"
                                                            (change)="checkall('isEditAll','isEdit')"></th>
                                                    <th>DELETE <input type="checkbox" id="isDeleteAll"
                                                            (change)="checkall('isDeleteAll','isDelete')"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let u of UserRightsList; let i = index">
                                                    <td><input type="checkbox" id="allow{{i}}"
                                                            [checked]="u.Allow == 1">
                                                    </td>
                                                    <td><label>{{u.FormName}}</label></td>
                                                    <td><input type="checkbox" id="isAdd{{i}}"
                                                            [checked]="u.Add == 1">
                                                    </td>
                                                    <td><input type="checkbox" id="isEdit{{i}}"
                                                            [checked]="u.Edit == 1">
                                                    </td>
                                                    <td><input type="checkbox" id="isDelete{{i}}"
                                                            [checked]="u.Del == 1">
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3 pt-2" style="margin-left: -5px;"
                             *ngIf="UserRightsList != undefined && UserRightsList.length > 0">
                            <button type="button" class="btn btn-success" (click)="setUserRights()" 
                                style="margin: 5px;">Save</button>
                            <button type="button" class="btn btn-primary" style="margin: 5px;"
                                (click)="resetAll()">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>